/* eslint-disable react-hooks/exhaustive-deps */
import useApi from "hooks/useApi";
import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useMemo,
} from "react";
import Constants from "utils/constants";

import ModalCheckList from "components/modals/StoreChecklistModal";
import Repository from "repository";
import { GlobalContext } from "./GlobalContext";

export const StoreStatusContext = createContext();

export const StoreStatusProvider = ({ children }) => {
  const [storeStatus, setStoreStatus] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [showChecklist, setShowChecklist] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [errorModal, setErrorModal] = useState({ open: false, message: "" });
  const { user } = useContext(GlobalContext);

  const idUser = useMemo(() => user?.id, [user]);

  const url = `${Constants.endpoints.getStoreStatus
    .replace("ID_LOJA", selectedStore?.id)
    .replace("ID_USER", idUser)}`;

  const GetUserHasLoggedBefore = useApi(
    Constants.endpoints.getUserHasLoggedBefore,
    "GET",
    {},
    {},
    true
  );
  const GetStoreList = useApi(Constants.endpoints.getStoresList, "GET", {}, {});
  const GetStoreStatus = useApi(url, "GET", {}, {});
  const PostSaveChecklist = useApi(
    Constants.endpoints.postStoreChecklist,
    "POST"
  );

  const checkUserStatus = async () => {
    const response = await GetUserHasLoggedBefore.callApi({
      idUsuario: idUser,
    });
    if (response.data) {
      const needToShowModal = !response.data.operadorPresente;
      if (needToShowModal) {
        await GetStoreList.callApi();
        setSelectedStore({ id: response.data.idLoja });
      }
      //setShowModal(needToShowModal);
    }
  };

  useEffect(() => {
    if (idUser) {
      checkUserStatus();
    }
  }, [ idUser]);
  const checkStoreStatus = async () => {
    try {
      const foundStore = GetStoreList.data?.find(
        (s) => s.id === selectedStore?.id
      );

      const response = await GetStoreStatus.callApi();

      const json = response.data;
      setShowChecklist(!json?.aberta);

      setStoreStatus({
        aberta: json?.aberta || false,
        usuarioPertenceLoja: json?.usuarioPertenceLoja,
        loja: {
          nome: foundStore?.nome,
          idLoja: selectedStore?.id,
          endereco: foundStore?.endereco?.logradouro,
        },
        operadorAberturaLoja: {
          idFuncionario: idUser,
          nome: user?.nomeTitular,
        },
      });
    } catch (error) {
      setErrorModal({
        message: error?.response?.data?.mensagem ?? "Houve um erro",
        open: true,
      });
    }
  };

  const saveChecklist = async (checklist) => {
    const body = {
      loja: storeStatus.loja,
      operadorAberturaLoja: storeStatus.operadorAberturaLoja,
      pertenceLoja: storeStatus?.usuarioPertenceLoja,
      alertaOperadorLoja: true,

      ...(!storeStatus.aberta && { checkList: checklist }),
    };
    const response = await PostSaveChecklist.callApi(body);
    if (response.status !== 201) {
      setErrorModal({
        message: response?.mensagem ?? "Houve um erro",
        open: true,
      });
      return;
    }
    if (response.status === 201) {
      setShowModal(false);
      setShowChecklist(false);
      Repository.storage.set(Repository.keys.CHECKLIST_STORE, {
        timestamp: new Date(),
        ok: true,
      });
    }
  };

  return (
    <StoreStatusContext.Provider
      value={{
        storeStatus,
        checkStoreStatus,
        stores: GetStoreList.data ?? [],
        isLoading: GetStoreStatus.loading || PostSaveChecklist.loading,
        isLoadingStores: GetStoreList.loading,
        setSelectedStore,
        showChecklist,
        saveChecklist,
        showModal,
        setShowChecklist,
        selectedStore,
        errorModal,
        setErrorModal,
      }}
    >
      {showModal && <ModalCheckList />}

      {children}
    </StoreStatusContext.Provider>
  );
};
